import { OfflineConstants } from "../OfflineConstants";

const songsheetsCacheIdentifier = buildCacheIdentifier(
  OfflineConstants.songsheetfilesCacheName,
);

export function deleteSongsheetFile(url: string): Promise<boolean> {
  return deleteResourceInOfflineAvailableContentCache(
    songsheetsCacheIdentifier,
    url,
    false,
  );
}

export function deleteAllCaches(): Promise<boolean> {
  return window.caches.keys().then(function (cacheNames) {
    return Promise.all(
      cacheNames.map(function (cacheName) {
        return caches.delete(cacheName);
      }),
    ).then((results) => results.every(Boolean));
  });
}

function deleteResourceInOfflineAvailableContentCache(
  cacheIdentifier: string,
  url: string,
  quietDelete: boolean = false,
): Promise<boolean> {
  console.info("going to delete: " + url);
  return window.caches.open(cacheIdentifier).then(function (cache) {
    return cache.delete(url).then(function (success) {
      if (!success) {
        if (quietDelete) {
          console.info(
            "Deleting url did not work. But no error will be returned because quietDelete is set to true",
            url,
          );
        } else {
          console.info("Deleting url did not work. Returning false", url);
        }
      }
      return Promise.resolve(success || quietDelete);
    });
  });
}

export function findAllSongsheetCacheKeys(): Promise<string[]> {
  return window.caches
    .open(songsheetsCacheIdentifier)
    .then(function (cache) {
      return cache.keys();
    })
    .then(function (requests) {
      return requests.map(function (request) {
        return request.url;
      });
    });
}

export function addToCache(url: string, response: Response) {
  if (response.ok) {
    return caches.open(songsheetsCacheIdentifier).then(function (cache) {
      return cache.put(url, response);
    });
  } else {
    throw Error(
      "Response status for " +
        url +
        " was " +
        response.status +
        ". Response will not be added to cache.",
    );
  }
}

export function buildCacheIdentifier(identifier: string) {
  return `${OfflineConstants.prefix}-${identifier}-${OfflineConstants.suffix}`;
}
